import * as React from "react";
import { Link } from "gatsby";

const Article = ({ id, title, date, slug, tags }) => {
  return (
    <Link to={`/blog/${slug}`}>
    <div
      key={id}
      className="
      relative
      article-card
      flex flex-col justify-around
      w-100 
      hover:bg-gradient-to-r from-pink to-purple 
      bg-white dark:bg-indigo-900 rounded-lg drop-shadow-lg p-5 mb-10"
    >
          <div>
            <h4 className="ibm-font text-xl sm:text-2xl">{title}</h4>
          </div>
          <div>
            <p className="mt-5 mb-10 lg:mb-0">Posté le: {date}</p>
            <div className="flex flex-row flex-wrap mt-5 w-full absolute bottom-2 left-2 p-2">
              {tags && tags.map((tag) => (
                <div>
                  {tag === "Angular" && (
                    <div className="bg-amber-400 px-3 m-1 rounded-md text-primary">
                      {tag}
                    </div>
                  )}
                  {tag === ".NET" && (
                    <div className="bg-lime-400 px-3 m-1  rounded-md text-primary">
                      {tag}
                    </div>
                  )}
                  {tag === "Git" && (
                    <div className="bg-sky-400 px-3 m-1 rounded-md text-primary">
                      {tag}
                    </div>
                  )}
                  
                   {tag === "Javascript" && (
                    <div className="bg-violet-400 px-3 m-1 rounded-md text-primary">
                      {tag}
                    </div>
                  )}
                   {tag === "UX/UI" && (
                    <div className="bg-fuchsia-400 px-3 m-1 rounded-md text-primary">
                      {tag}
                    </div>
                  )}
                   {tag === "CSS" && (
                    <div className="bg-rose-400 px-3 m-1 rounded-md text-primary">
                      {tag}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
    </div>
    </Link>
  );
};

export default Article;
